// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 22H2V13H11V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22H13V13H22V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11 11H2V2H11V11Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19.4551 4.54395L22.6797 6L19.4551 7.45508L18 10.6797L16.5439 7.45508L13.3203 6L16.5439 4.54395L18 1.32031L19.4551 4.54395Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-tool-filled')
export default class AiToolFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-tool-filled',
    }
  }
}
